module.exports = __webpack_public_path__ + "img/electronic_electric_enabled.a7ea04ef.svg";